import Vue from "vue";

export default {
  setTabsData(state, payload) {
    payload.tabs.forEach(tab => {
      tab.resourceData = {};
      tab.screenshotsData = {};
      tab.recordedScreenshots = {};
      tab.stepsContext = {};
      tab.consoleAndNetworklog = {};
      tab.extensions = [];
    });
    state.tabsData = payload;
  },
  setTestdefectcount(state, payload) {
    state.testdefectcount = payload;
  },
  setIntegrations(state, payload) {
    state.integrations = payload;
  },
  setSummaries(state, payload) {
    state.summaries = payload;
  },
  setMappedDataSource(state, payload) {
    console.log("tdm setmappeddatasource mutation", payload);
    state.mappedDataSource = payload;
  },
  setAutoMappedDataSourcesFlag(state, payload) {
    state.autoMappedDataSourcesFlag = payload;
  },
  setScreenshotsData(state, payload) {
    const tabIndex = state.tabsData.tabs.findIndex((tab) => tab.name == (payload.tabKey || "actions"));
    state.tabsData.tabs[tabIndex].screenshotsData = payload.data;
  },
  setRecordedScreenshots(state, payload) {
    const tabIndex = state.tabsData.tabs.findIndex((tab) => tab.name == (payload.tabKey || "actions"));
    state.tabsData.tabs[tabIndex].recordedScreenshots = payload.data;
  },
  setStepsContext(state, payload) {
    const tabIndex = state.tabsData.tabs.findIndex((tab) => tab.name == (payload.tabKey || "actions"));
    state.tabsData.tabs[tabIndex].stepsContext = payload.data;
  },
  setConsoleAndNetworklog(state, payload) {
    const tabIndex = state.tabsData.tabs.findIndex((tab) => tab.name == (payload.tabKey || "actions"));
    state.tabsData.tabs[tabIndex].consoleAndNetworklog = payload.data;
  },
  setBrowserData(state, payload) {
    const tabIndex = state.tabsData.tabs.findIndex((tab) => tab.name == (payload.tabKey || "actions"));
    state.tabsData.tabs[tabIndex].resourceData = payload.resourceData;
  },
  setLastRunJobPath(state, payload) {
    state.lastRunJobPath = payload;
  },
  setMlData(state, payload) {
    state.mlData = payload;
  },
  setQuickSelectAction(state, payload) {
    state.quickSelectAction = payload;
  },
  setQuickSelect(state, payload) {
    state.quickSelect = payload;
  },
  setUseFilteredData(state, payload) {
    state.useFilteredData = payload
  },
  setLoadQuick(state, payload) {
    state.loadQuick = payload;
  },
  setSelectedRegions(state, payload) {
    state.selectedRegions = payload;
  },
  setLoadRegionSelect(state, payload) {
    state.loadRegionSelect = payload;
  },
  setRegionSelectChange(state, payload) {
    state.regionSelectChange = payload;
  },
  setRegionSelect(state, payload) {
    state.regionSelect = payload;
  },
  setRegionSelectAction(state, payload) {
    state.regionSelectAction = payload;
  },
  setAddActionPassDetail(state, payload) {
    state.addActionPassDetail = payload;
  },
  setAddActionData(state, payload) {
    state.addActionData = payload;
  },
  setActionIdNoML(state, payload) {
    state.actionIdNoML = payload;
  },
  setQuickSelectedElement(state, payload) {
    state.quickSelectedElement = payload;
  },
  setIgnoreElementsChange(state, payload) {
    state.ignoreElementsChange = payload
  },
  setIgnoreElements(state, payload) {
    state.ignoreElements = payload;
  },
  addIgnoreElements(state, payload) {
    let index = state.ignoreElements.findIndex((element) => {
      return payload.idNode == element.idNode;
    });
    if (index > -1) {
      state.ignoreElements.splice(index, 1);
    } else {
      state.ignoreElements.push(payload);
    }
  },
  setExtensions(state, payload) {
    Vue.set(state, "extensions", payload);
  },
  setAlertQ(state, payload) {
    state.alertQ = payload;
  },
  setGlobalNewTagData(state, payload) {
    state.globalNewTagData = payload;
  },
  setGlobalVISData(state, payload) {
    state.globalVISData = payload;
  },
  setGlobalSmartFixData(state, payload) {
    state.globalSmartFixData = payload;
  },
  setMlData(state, payload) {
    state.mlData = payload;
  },
  setActionsAnamolyStorage(state, payload) {
    state.actionsAnamolyStorage = payload;
  },
  setActionLog(state, payload) {
    const tabData = this.$route.params.browserId ? this.$store.state.testDetail.tabsData.tabs.find((tab) => {
      return tab.resource_id == this.$route.params.browserId;
    }) : this.$store.state.testDetail.tabsData.tabs[0];
    if (payload?.error === "details_not_found") {
      tabData.resourceData.actiondataarr = payload;
    } else {
      if (Array.isArray(payload)) {
        tabData.resourceData.actiondataarr = payload;
      } else if (payload instanceof Object) {
        tabData.resourceData.actiondataarr = [payload];
      } else if (typeof payload != 'undefined') {
        tabData.resourceData.actiondataarr = [];
      }
      function parseVariable(actionArray) {
        const varibaleNameList = [];
        actionArray.map((action) => {
          if (action.action_type === "setVariable" && action.type === "local") {
            varibaleNameList.push(action.name);
          }
          if (action.action_type === "customcode") {
            if (action.elementCode) {
              const matches = action.elementCode.toString().match(/fze\.local\.(\w+)\s?=/gi);
              if (matches) {
                const items = matches.map(m => m.replace('fze.local.', '').replace('=', '').replace(' ', ''));
                Array.from(new Set(items)).map(x => {
                  varibaleNameList.push(x);
                });
              }
            }
          }
        });
        return varibaleNameList;
      };
      let localVariables = [...state.monacoLocalVariables];
      tabData.resourceData.actiondataarr?.map((value) => {
        const variables = parseVariable(value.child ?? []);
        localVariables = [...localVariables, ...variables];
      });
      state.monacoLocalVariables = localVariables;
    }
  },
  setLoadSpinner(state, payload) {
    state.loadSpinner = payload;
  },
  setActionUpdate(state, payload) {
    if (!state.actionUpdate[payload.id]) {
      state.actionUpdate[payload.id] = {};
    }
    if (payload.key) {
      const oldValue = state.allActions?.[payload.id]?.[payload.key] ?? "";
      payload.oldValue = oldValue;
      if (oldValue !== payload.value) {
        state.actionUpdate[payload.id][payload.key] = payload;
        if (!state.actionChangesCounts[payload.id]) {
          state.actionChangesCounts[payload.id] = [];
        }
        if (!state.actionChangesCounts[payload.id].includes(payload.key)) {
          state.actionChangesCounts[payload.id].push(payload.key);
        }
      } else {
        delete state.actionUpdate[payload.id][payload.key];
        if (Array.isArray(state.actionChangesCounts[payload.id])) {
          const index = state.actionChangesCounts[payload.id].indexOf(payload.key);
          if (index > -1) {
            state.actionChangesCounts[payload.id].splice(index, 1);
          }
        }
      }
    } else {
      state.actionUpdate[payload.id] = {};
      state.actionChangesCounts[payload.id] = [];
    }
  },
  removeExtension(state, payload) {
    //remove global extension
    let extensions = state.extensions.map((extension) => {
      if (extension.id == payload) {
        extension.name = "";
        extension.action_id = "";
      }
      return extension;
    });
    Vue.set(state, "extensions", extensions);
  },
  resetBreakpoints(state) {
    state.breakpoints = [];
    // Vue.set(state, "breakpoints", state.breakpoints);
  },
  addOrRemoveBreakpoint(state, payload) {
    let index = state.breakpoints.indexOf(payload);
    if (index > -1) {
      state.breakpoints.splice(index, 1);
    } else {
      state.breakpoints.push(payload);
    }
    // Vue.set(state, "breakpoints", state.breakpoints);
  },
};
